import Navbar from "./Navbar";
import BottomNav from "./BottomNav";
import MessagesFAB from "./MessagesFAB";
import DesktopLayout from "./DesktopLayout";
import { Outlet } from "react-router-dom";
import { Toaster } from "./ui/sonner";

export default function Layout() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="app-layout">
      <Navbar />
      <MessagesFAB />
      <DesktopLayout>
        <Outlet />
      </DesktopLayout>
      <BottomNav />
      <Toaster position="top-right" richColors theme="dark" />
    </div>
  );
}
